(function () {
  var root = document.getElementById('finder-clean');
  if (!root || root.__init) return;
  root.__init = true;

  document.addEventListener('3idee:geld-bereit', function(){
    if(!state.presets.length && !state.required.length) return;
    renderRequired(); renderPresets(); renderOptional(); renderSummary();
  });

  var A = {};
  function _vesaChip(){ return A._vesaChip ? A._vesaChip.apply(null, arguments) : undefined; }
  function renderSlots(){ return A.renderSlots ? A.renderSlots.apply(null, arguments) : undefined; }
  function showVesaGate(){ return A.showVesaGate ? A.showVesaGate.apply(null, arguments) : undefined; }
  function showHalterungFallback(){ return A.showHalterungFallback ? A.showHalterungFallback.apply(null, arguments) : undefined; }
  function satzBauen(){ return A.satzBauen ? A.satzBauen.apply(null, arguments) : undefined; }
  function bloeckeSetzen(){ return A.bloeckeSetzen ? A.bloeckeSetzen.apply(null, arguments) : undefined; }
  function renderRequired(){ return A.renderRequired ? A.renderRequired.apply(null, arguments) : undefined; }
  function renderPresets(){ return A.renderPresets ? A.renderPresets.apply(null, arguments) : undefined; }
  function renderOptional(){ return A.renderOptional ? A.renderOptional.apply(null, arguments) : undefined; }
  function renderVesaCta(){ return A.renderVesaCta ? A.renderVesaCta.apply(null, arguments) : undefined; }
  function renderSummary(){ return A.renderSummary ? A.renderSummary.apply(null, arguments) : undefined; }
  function showPostAdd(){ return A.showPostAdd ? A.showPostAdd.apply(null, arguments) : undefined; }
  function hidePostAdd(){ return A.hidePostAdd ? A.hidePostAdd.apply(null, arguments) : undefined; }
  function reiterBauen(){ return A.reiterBauen ? A.reiterBauen.apply(null, arguments) : undefined; }
  function syncVesaUI(){ return A.syncVesaUI ? A.syncVesaUI.apply(null, arguments) : undefined; }
  function buildVesaBox(){ return A.buildVesaBox ? A.buildVesaBox.apply(null, arguments) : undefined; }
  function openVesaModal(){ return A.openVesaModal ? A.openVesaModal.apply(null, arguments) : undefined; }
  function closeVesaModal(){ return A.closeVesaModal ? A.closeVesaModal.apply(null, arguments) : undefined; }
  function setSummaryEmpty(){ return A.setSummaryEmpty ? A.setSummaryEmpty.apply(null, arguments) : undefined; }
  function updateActiveState(){ return A.updateActiveState ? A.updateActiveState.apply(null, arguments) : undefined; }
  function oneWort(){ return A.oneWort ? A.oneWort.apply(null, arguments) : undefined; }

  var PROXY = '/apps/monitor-db';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function abruf(url){
    if(window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function(r){ return r.json(); });
  }
  function ausfall(e){ return !!(e && e.engineAus && window.EngineStatus); }
  var WA_TEXT = 'Hallo, ich suche eine Halterung. Mein Monitor ist: ';
  var MAX_MON = 4;

  var d = root.dataset;

  var _decEl = document.createElement('textarea');
  function _dec(s){ if(s==null||s==='') return ''; _decEl.innerHTML=String(s); return _decEl.value; }

  var S = {
    einsViele:         _dec(d.sEinsViele),
    einsEine:          _dec(d.sEinsEine),
    einsKeine:         _dec(d.sEinsKeine),
    gleicheViele:      _dec(d.sGleicheViele),
    gleicheEine:       _dec(d.sGleicheEine),
    gleicheKeine:      _dec(d.sGleicheKeine),
    verschiedeneViele: _dec(d.sVerschiedeneViele),
    verschiedeneEine:  _dec(d.sVerschiedeneEine),
    verschiedeneKeine: _dec(d.sVerschiedeneKeine),
    sonderEins:        _dec(d.sSonderEins),
    sonderMehrere:     _dec(d.sSonderMehrere),
    adapterEiner:      _dec(d.sAdapterEiner),
    adapterBeide:      _dec(d.sAdapterBeide),
    adapterAlle:       _dec(d.sAdapterAlle),
    adapterNur:        _dec(d.sAdapterNur),
    adapterEinige:     _dec(d.sAdapterEinige),
    tischOffen:        _dec(d.sTischOffen),
    plattePflicht:     _dec(d.sPlattePflicht),
    noetig:            _dec(d.sNoetig),
    empfohlen:         _dec(d.sEmpfohlen)
  };

  var T = {

    laedt:           _dec(d.tLaedt)           || 'Einen Moment …',
    ladenFehler:     _dec(d.tLadenFehler)     || 'Das Produkt lässt sich gerade nicht laden.',
    reqUnbekannt:    _dec(d.tReqUnbekannt)    || 'Erforderliches Produkt',
    reqUnbestellbar: _dec(d.tReqUnbestellbar) || 'Nicht direkt bestellbar — wir helfen weiter.',
    placeholder: _dec(d.monPlaceholder) || 'Marke & Modell eingeben …',
    duplicate:   _dec(d.tDuplicate)     || 'Duplizieren',
    remove:      _dec(d.tRemove)        || 'Entfernen',
    loading:     _dec(d.tLoading)       || 'Passende Lösungen werden gesucht …',
    empty:       _dec(d.tEmpty)         || 'Für dein Setup liegen aktuell keine Lösungen vor.',
    soldout:     _dec(d.tSoldout)       || 'Ausverkauft',
    neu:         _dec(d.tNeu)           || 'Neu',
    korbWort:    _dec(d.tKorbWort)      || '%d Artikel hinzufügen',
    monitorTitel:  _dec(d.tMonitorTitel)  || 'Dein Monitor',
    monitoreTitel: _dec(d.tMonitoreTitel) || 'Deine Monitore',
    preorder:    _dec(d.tPreorder)      || 'Vorbestellung',

    traglastKnapp: _dec(d.tTraglastKnapp) || 'Nahe an der Traglast',
    lieferbarAb: _dec(d.tLieferbarAb)   || 'Lieferbar ab %s',
    mountWall:   _dec(d.tMountWall)     || 'Wandhalterungen',
    mountDesk:   _dec(d.tMountDesk)     || 'Tischhalterungen',
    mountOther:  _dec(d.tMountOther)    || 'Weitere Monitorhalterungen',
    tabLeer:     _dec(d.tTabLeer)       || 'Für deine Angaben ist hier nichts dabei',

    withAdapter: _dec(d.tWithAdapter)   || 'mit VESA Adapter',

    withAdapters:_dec(d.tWithAdapters)  || 'mit %d Adaptern',
    sparst:      _dec(d.tSparst)        || 'Du sparst %s',
    vesaNeeded:  _dec(d.tVesaNeeded)    || 'VESA-Angaben fehlen',
    vesaRecessed:_dec(d.tVesaRecessed)  || 'vertieft',
    waIntro:     _dec(d.tWaIntro)       || 'Hallo, ich brauche Hilfe bei diesem Setup:',
    waMonitors:  _dec(d.tWaMonitors)    || 'Monitore',
    waMount:     _dec(d.tWaMount)       || 'Montage',
    waSelection: _dec(d.tWaSelection)   || 'Meine Auswahl',
    waTotal:     _dec(d.tWaTotal)       || 'Gesamt',
    waNoteNone:  _dec(d.tWaNoteNone)    || 'kein VESA-Muster',
    openLabel:   _dec(d.tOpenLabel)     || 'Noch zu klären',
    teilFuer:    _dec(d.tTeilFuer)      || '@TEIL@ für @GERAETE@',
    novesaLabel: _dec(d.tNovesaLabel)   || 'Kein VESA',
    novesaTitle: _dec(d.tNovesaTitle)   || 'Monitor ohne VESA-Aufnahme',
    novesaText:  _dec(d.tNovesaText)    || '',
    novesaBlockKopf: _dec(d.tNovesaBlockKopf) || '',
    slotErsetzen:    _dec(d.tSlotErsetzen) || 'Monitor ersetzen',
    slotAbbrechen:   _dec(d.tSlotAbbrechen) || 'Abbrechen',
    openSummary: _dec(d.tOpenSummary)   || '! Für %s% ist das VESA-Muster noch offen',
    openSummarySub: _dec(d.tOpenSummarySub) || '',
    requiredLabel: _dec(d.tRequiredLabel) || 'Erforderlich',
    requiredLabelRec: _dec(d.tRequiredLabelRec) || 'Empfohlen',

    liegtBeiLabel: _dec(d.tLiegtBeiLabel) || 'liegt deinem Monitor bei',

    waLink: _dec(d.tWaLink) || '',
    summaryRequiredLabel: _dec(d.tSummaryRequiredLabel) || 'Pflicht',
    presetLabel: _dec(d.tPresetLabel)   || 'gewählte Lösung',
    optionalLabel: _dec(d.tOptionalLabel) || 'optional',
    nothing:     _dec(d.tNothing)       || 'Wähle oben eine Lösung, dann erscheint hier deine Bestellübersicht.',

    einzelAdd:   _dec(d.tEinzelAdd)     || 'Adapter einzeln kaufen',
    einzelHalterung: _dec(d.tEinzelHalterung) || 'Halterung einzeln kaufen',
    vesaOk:      _dec(d.tVesaOk)        || 'VESA passt',
    inStock:     _dec(d.tInStock)       || 'Auf Lager',

    gefertigt:   _dec(d.tGefertigt)     || 'Wird für dich gefertigt',
    vorbestellbar: _dec(d.tVorbestellbar) || 'Vorbestellbar',
    nichtVerfuegbar: _dec(d.tNichtVerfuegbar) || 'Nicht verfügbar',

    keinModell:  _dec(d.tKeinModell)    || 'Kein Modell gefunden',
    sucheAus:    _dec(d.tSucheAus)      || 'Die Modellsuche ist gerade nicht erreichbar. Schreib uns dein Modell — wir sagen dir sofort, was passt.',
    fehler:      _dec(d.tFehler)        || 'Fehler',
    korbNichtBereit: _dec(d.tKorbNichtBereit) || 'Warenkorb nicht bereit',
    warum:       _dec(d.tWarum)         || 'Warum?',
    altOneOf:    _dec(d.tAltOneOf)      || 'eine Variante genügt',
    fehltPflicht:   _dec(d.tFehltPflicht)   || '! Erforderliches Produkt fehlt noch',
    fehltEmpfohlen: _dec(d.tFehltEmpfohlen) || '! Empfohlenes Produkt fehlt noch',
    fehltHinweis:   _dec(d.tFehltHinweis)   || 'Auswählen, um dein Setup zu vervollständigen',
    nichtAufLager:  _dec(d.tNichtAufLager)  || '! Ein Teil deiner Auswahl ist aktuell nicht auf Lager',

    besteWahl:      _dec(d.tBesteWahl)      || 'Beliebt',
    setupKomplett:  _dec(d.tSetupKomplett)  || 'Setup komplettieren',
    passendFuer:    _dec(d.tPassendFuer)    || 'Für %s',
    bisZu:          _dec(d.tBisZu)          || 'Bis zu {{ betrag }} {{ titel }}',
    fehltTrotzdem:  _dec(d.tFehltTrotzdem)  || ''
  };
  WA_TEXT = _dec(d.tWaText) || WA_TEXT;
  var BUNDLE_AMOUNT = Math.max(0, parseFloat(d.bundleAmount) || 0);

  var BUNDLE_AMOUNT_FLEXI = Math.max(0, parseFloat(d.bundleAmountFlexi) || 0);

  var BUNDLE_AMOUNT_FLEXI_HOCH = Math.max(0, parseFloat(d.bundleAmountFlexiHoch) || 0);
  var BUNDLE_FLEXI_AB = Math.max(0, parseFloat(d.bundleFlexiAb) || 0);
  var BUNDLE_TITEL = _dec(d.bundleTitel) || '';

  var STATIC_ZUBEHOER = [];
  (function(){
    var el = document.querySelector('[data-role="zubehoer-static-data"]');
    if(!el) return;
    try { STATIC_ZUBEHOER = JSON.parse(el.textContent) || []; } catch(e){ STATIC_ZUBEHOER = []; }
  })();

  var $  = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return (r || root).querySelectorAll(s); };
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function _mediaUrl(u){ return (typeof u==='string' && u.indexOf('/media/')===0) ? PROXY+u : u; }

  var CURRENCY = _dec(d.currency) || 'EUR';
  var MONEY_FORMAT = _dec(d.moneyFormat) || '{{amount_with_comma_separator}} €';

  function _price(cents){
    if(cents==null) return '';
    if(typeof window.__3ideeGeld === 'function'){
      try { return window.__3ideeGeld(cents, MONEY_FORMAT, CURRENCY); } catch(e){}
    }
    var precision = 2, thousands = ',', decimals = '.';
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(MONEY_FORMAT);
    switch(m ? m[1] : 'amount'){
      case 'amount_no_decimals': precision = 0; break;
      case 'amount_with_comma_separator': thousands = '.'; decimals = ','; break;
      case 'amount_no_decimals_with_comma_separator': thousands = '.'; precision = 0; break;
      case 'amount_no_decimals_with_space_separator': thousands = ' '; precision = 0; break;
      case 'amount_with_space_separator': thousands = ' '; decimals = ','; break;
      case 'amount_with_period_and_space_separator': thousands = ' '; decimals = '.'; break;
      case 'amount_with_apostrophe_separator': thousands = "'"; decimals = '.'; break;
    }
    var parts = (cents/100).toFixed(precision).split('.');
    var whole = (parts[0]||'0').replace(/\d(?=(\d\d\d)+(?!\d))/g, function(c){ return c+thousands; });
    var num = precision<=0 ? whole : whole+decimals+parts[1];
    return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, num);
  }

  var HOLZ_STABIL_AB_CM = 3;
  function deskMaterial(gruppe, dickeCm){
    if(gruppe === 'glas') return 'glass';
    if(gruppe === 'leicht') return 'honeycomb';
    if(gruppe === 'beschichtet') return 'mdf';
    if(gruppe === 'holz') return (dickeCm && dickeCm >= HOLZ_STABIL_AB_CM) ? 'solid_wood_thick' : 'solid_wood_thin';
    return '';
  }
  function _num(n){ return (Math.round(n*100)/100).toString().replace('.',','); }
  var SEARCH_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="6.5" cy="6.5" r="5" stroke="currentColor" stroke-width="1.5"/><path d="M10.5 10.5l4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var CART_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9" cy="21" r="1"/><circle cx="18" cy="21" r="1"/><path d="M3 3h2l2.2 11.4a1 1 0 0 0 1 .8h9.5a1 1 0 0 0 1-.8L20.5 8H6"/></svg>';

  var state = {
    slots: [ { monitor: null } ],
    mount: '', mountKey: '', deskType: '', thick: '', thickUnknown: false,

    vesaBy: {},

    vesaOk: null,
    presets: [],
    required: [],
    optional: [],
    optionalRules: [],
    optionalFunnel: [],
    selPreset: null,
    optOn: {},
    reqOn: {},

    reqAus: {}
  };
  var hasAutoScrolled = false;

  var finderRun = 0;

  var funnelRun = 0;

  var STORE_KEY = 'fn3state:' + location.pathname;
  function _b64(str){ return btoa(unescape(encodeURIComponent(str))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); }
  function _unb64(code){ var t = String(code).replace(/-/g,'+').replace(/_/g,'/'); while(t.length % 4) t += '='; return decodeURIComponent(escape(atob(t))); }
  function setupCode(st){
    var o = { r: st.refs };
    if(st.mount) o.m = st.mount;
    if(st.mountKey) o.k = st.mountKey;
    if(st.deskType) o.d = st.deskType;
    if(st.thick) o.t = st.thick;
    if(st.thickUnknown) o.u = 1;
    if(st.presetSku) o.p = st.presetSku;
    if(st.reqAus && st.reqAus.length) o.a = st.reqAus;
    var v = {};
    Object.keys(st.vesaBy || {}).forEach(function(ref){
      var x = st.vesaBy[ref] || {};
      if(x.pattern || x.otherPattern || x.recessed || x.shape) v[ref] = [x.pattern||'', x.otherPattern||'', x.recessed||'', x.shape||''];
    });
    if(Object.keys(v).length) o.v = v;
    return _b64(JSON.stringify(o));
  }
  function ausSetupCode(code){
    var o = JSON.parse(_unb64(code));
    if(!o || !o.r || !o.r.length) return null;
    var v = {};
    Object.keys(o.v || {}).forEach(function(ref){ var x = o.v[ref] || []; v[ref] = { pattern:x[0]||'', otherPattern:x[1]||'', recessed:x[2]||'', shape:x[3]||'' }; });
    return { refs: o.r.map(String), mount: o.m||'', mountKey: o.k||'', deskType: o.d||'', thick: o.t||'',
             thickUnknown: !!o.u, vesaBy: v, presetSku: o.p||'', reqAus: o.a||[] };
  }
  function adresseParam(name){ var m = location.search.match(new RegExp('[?&]' + name + '=([^&]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function adresseSetzen(werte){
    try{
      var teile = location.search.replace(/^\?/, '').split('&').filter(function(x){ return x && !Object.prototype.hasOwnProperty.call(werte, x.split('=')[0]); });
      Object.keys(werte).forEach(function(k){ if(werte[k]) teile.push(k + '=' + encodeURIComponent(werte[k]).replace(/%2C/g, ',')); });
      history.replaceState(history.state, '', location.pathname + (teile.length ? '?' + teile.join('&') : '') + location.hash);
    }catch(e){}
  }
  function saveState(){
    merkeGlobal();
    try{
      var refs = state.slots.map(function(s){ return s.monitor ? s.monitor.ref : null; }).filter(Boolean);
      if(!refs.length){ sessionStorage.removeItem(STORE_KEY); adresseSetzen({ s: '' }); return; }

      var gewaehlt = (state.selPreset != null && state.presets[state.selPreset])
        ? (state.presets[state.selPreset].sku || '') : '';
      var stand = {
        refs: refs, mount: state.mount, mountKey: state.mountKey, deskType: state.deskType,
        thick: state.thick, thickUnknown: state.thickUnknown, vesaBy: state.vesaBy,
        presetSku: gewaehlt, reqAus: Object.keys(state.reqAus)
      };
      sessionStorage.setItem(STORE_KEY, JSON.stringify(stand));
      adresseSetzen({ s: setupCode(stand) });
    }catch(e){}
  }
  function clearState(){ try{ sessionStorage.removeItem(STORE_KEY); }catch(e){} merkeGlobal(); }

  var wunschPreset = null;

  var GLOBAL_KEY = '3idee_auswahl';

  function tischAngabe(){
    var dicke = (state.thick && !state.thickUnknown) ? parseFloat(state.thick) : null;
    if(!dicke || !isFinite(dicke)) dicke = null;
    var art = deskMaterial(state.deskType, dicke);
    if(!art && !dicke) return null;
    return { art: art, gruppe: state.deskType || '', dicke_cm: dicke, quelle: 'finder' };
  }

  function merkeGlobal(){
    try{
      var mons = state.slots.map(function(s){ return s.monitor; }).filter(Boolean);
      if(!mons.length){ localStorage.removeItem(GLOBAL_KEY); }
      else {
        localStorage.setItem(GLOBAL_KEY, JSON.stringify({
          refs: mons.map(function(m){ return m.ref; }),
          name: mons[0].name,

          namen: mons.map(function(m){ return m.name; }),
          anzahl: mons.length,
          mount: state.mountKey || '',

          tisch: tischAngabe(),
          pfad: location.pathname,
          zeit: Date.now()
        }));
      }

      document.dispatchEvent(new CustomEvent('finder:auswahl'));
    }catch(e){}
  }

  function ladeAusfall(mos){
    if((mos || []).filter(Boolean).length) return false;
    if(!window.EngineStatus || !window.EngineStatus.gestoert()) return false;
    state.slots = [{ monitor:null }];
    renderSlots();
    var alt = document.querySelector('[data-fn-ladeaus]'); if(alt) alt.remove();
    var box = document.createElement('div');
    box.className = 'fn-ddi fn-ddi--aus';
    box.setAttribute('data-fn-ladeaus', '');
    box.innerHTML = window.EngineStatus.hinweisHtml(T.sucheAus, WA_TEXT);

    var heroForm = document.querySelector('[data-fh2-form]');
    var heroListe = heroForm && heroForm.querySelector('[data-fh2-dd]');
    if(root.offsetParent === null && heroForm && heroListe){
      heroForm.hidden = false;
      heroListe.innerHTML = '';
      heroListe.appendChild(box);
      heroListe.hidden = false;
      var hw = heroForm.closest('.finder-hero'); if(hw) hw.classList.add('finder-hero--liste-offen');

      setTimeout(function(){ heroForm.scrollIntoView({ behavior:'smooth', block:'center' }); }, 150);
    } else {
      var ziel = $('#fn-slots');
      if(ziel && ziel.parentNode) ziel.parentNode.insertBefore(box, ziel);
    }
    if(!root.__ladeAusHorcht){
      root.__ladeAusHorcht = true;
      document.addEventListener('engine:status', function(e){
        if(e.detail && e.detail.gestoert) return;
        var h = document.querySelector('[data-fn-ladeaus]');
        if(!h) return;
        h.remove();
        uebernehmeGlobal();
      });
    }
    return true;
  }

  function uebernehmeGlobal(){
    var g; try{ g = JSON.parse(localStorage.getItem(GLOBAL_KEY) || 'null'); }catch(e){ return; }
    if(!g || !g.refs || !g.refs.length) return;

    if(g.mount && mountGroup){
      var wahl = mountGroup.querySelector('.fn-choice[data-mount-key="' + g.mount + '"]');
      if(wahl){
        state.mount = wahl.getAttribute('data-value') || '';
        state.mountKey = g.mount;
        mountGroup.querySelectorAll('.fn-choice').forEach(function(c){
          c.classList.toggle('is-sel', c.getAttribute('data-mount-key') === state.mountKey);
        });
      }
    }

    Promise.all(g.refs.map(loadMonitor)).then(function(mos){
      var filled = mos.filter(Boolean).map(function(m){ return { monitor:m }; });
      if(!filled.length){ ladeAusfall(mos); return; }
      state.slots = filled;
      renderSlots();
      runFinder();
    });
  }

  function restoreState(){
    var code = adresseParam('s');
    if(code){
      try{
        var geteilt = ausSetupCode(code);
        if(geteilt) sessionStorage.setItem(STORE_KEY, JSON.stringify(geteilt));
      }catch(e){}
    }

    if (/[?&]finder=neu(&|$)/.test(location.search)) {
      try {
        var sauber = location.pathname
          + location.search.replace(/([?&])finder=neu(&|$)/, '$1').replace(/[?&]$/, '')
          + location.hash;
        history.replaceState(null, '', sauber);
      } catch (e) {}
      return uebernehmeGlobal();
    }

    var raw; try{ raw = sessionStorage.getItem(STORE_KEY); }catch(e){ return uebernehmeGlobal(); }
    if(!raw) return uebernehmeGlobal();
    var st; try{ st = JSON.parse(raw); }catch(e){ return uebernehmeGlobal(); }
    if(!st || !st.refs || !st.refs.length) return uebernehmeGlobal();

    if (/[?&]setup=1(&|$)/.test(location.search)) {
      var gl = null;
      try { gl = JSON.parse(localStorage.getItem(GLOBAL_KEY) || 'null'); } catch(e){}
      if (gl && gl.refs && gl.refs.length
          && gl.refs.map(String).join(',') !== st.refs.map(String).join(',')) {
        return uebernehmeGlobal();
      }
    }
    state.mount=st.mount||''; state.mountKey=st.mountKey||''; state.deskType=st.deskType||'';
    state.thick=st.thick||''; state.thickUnknown=!!st.thickUnknown;
    wunschPreset = st.presetSku || null;
    (st.reqAus || []).forEach(function(sku){ state.reqAus[sku] = true; });
    if(st.vesaBy && typeof st.vesaBy === 'object'){
      Object.keys(st.vesaBy).forEach(function(ref){
        var v = st.vesaBy[ref] || {};
        state.vesaBy[ref] = { pattern:v.pattern||'', otherPattern:v.otherPattern||'', recessed:v.recessed||'', shape:v.shape||'' };
      });
    }
    if(mountGroup && state.mountKey){
      mountGroup.querySelectorAll('.fn-choice').forEach(function(c){ c.classList.toggle('is-sel', c.getAttribute('data-mount-key')===state.mountKey); });
    }
    if(deskSel && state.deskType) deskSel.value=state.deskType;
    if(thickInp && state.thick) thickInp.value=state.thick;
    if(typeof deskRmZeigen === 'function') deskRmZeigen();

    Promise.all(st.refs.map(loadMonitor)).then(function(mos){
      var filled = mos.filter(Boolean).map(function(m){ return { monitor:m }; });
      if(ladeAusfall(mos)) return;
      state.slots = filled.length ? filled : [{ monitor:null }];
      renderSlots();
      if(filledMonitors().length) runFinder();
    });
  }

  var slotsWrap = $('#fn-slots');
  var searchTimers = {}, lastQ = {};

  function filledMonitors(){
    var out=[];
    state.slots.forEach(function(s,i){ if(s.monitor){ s.monitor.slotIndex=i; out.push(s.monitor); } });
    return out;
  }

  function _vesaTplLabel(sel){
    if(!vesaTpl) return '';
    var el = vesaTpl.content.querySelector(sel);
    return el ? (el.textContent || '').trim() : '';
  }

  function _vesaAnswerSummary(ref){
    var v = state.vesaBy[ref] || {};
    if(!v.pattern) return '';
    var parts = [];
    if(v.pattern === 'other'){
      if(!v.otherPattern) return '';
      parts.push(_vesaTplLabel('[data-fn-vesa-other] option[value="'+v.otherPattern+'"]'));
    } else {
      parts.push(_vesaTplLabel('[data-fn-vesa="pattern"] [data-value="'+v.pattern+'"] strong'));
    }

    if(v.recessed === 'yes'){
      var shape = v.shape ? _vesaTplLabel('[data-fn-vesa="shape"] [data-value="'+v.shape+'"] strong') : '';
      parts.push(T.vesaRecessed + (shape ? ' ' + shape.toLowerCase() : ''));
    }
    return parts.filter(Boolean).join(' · ');
  }

  slotsWrap.addEventListener('input', function(e){
    var inp = e.target.closest('.fn-slot-inp'); if(!inp) return;
    var i = inp.getAttribute('data-slot');
    var dd = slotsWrap.querySelector('.fn-slot-dd[data-slot="'+i+'"]');
    var q = inp.value.trim(); lastQ[i] = q;
    clearTimeout(searchTimers[i]);
    if(q.length < 2){ if(dd){ dd.style.display='none'; dd.innerHTML=''; } return; }
    searchTimers[i] = setTimeout(function(){ doSearch(i, q, dd); }, 180);
  });

  slotsWrap.addEventListener('click', function(e){
    var ddi = e.target.closest('.fn-ddi[data-ref]');
    if(ddi){ var si = ddi.closest('.fn-slot').getAttribute('data-slot'); selectMonitor(+si, ddi.getAttribute('data-ref')); return; }
    var act = e.target.closest('[data-act]');
    if(act){
      var idx = +act.getAttribute('data-slot');
      var what = act.getAttribute('data-act');
      if(what==='rm') removeSlot(idx);
      else if(what==='sw') ersetzenSlot(idx);
      else if(what==='cancel') ersetzenAbbrechen(idx);
      else if(what==='dup') duplicateSlot(idx);
      else if(what==='vesa-toggle'){
        var slotEl = act.closest('.fn-slot');
        var mon = state.slots[idx] && state.slots[idx].monitor;
        if(slotEl && mon){
          var nowOpen = !slotEl.classList.contains('is-vesa-open');
          slotEl.classList.toggle('is-vesa-open', nowOpen);
          act.setAttribute('aria-expanded', String(nowOpen));
          if(nowOpen) vesaOpenSlots[mon.ref] = true; else delete vesaOpenSlots[mon.ref];
        }
      }
    }
  });

  function doSearch(i, q, dd){
    abruf(PROXY+'/monitors/search?q='+encodeURIComponent(q))
      .then(function(json){
        if(q !== lastQ[i] || !dd) return;
        var data = (json && json.data) || {};
        var list = (data.found && data.results && data.results.length) ? data.results : (data.similar || []);

        if(!json.ok || !list.length){ dd.innerHTML='<div class="fn-ddi fn-ddi--empty">'+esc(T.keinModell)+'</div>'; dd.style.display='block'; if(window.Suchebene) window.Suchebene.messen(); return; }
        dd.innerHTML = list.map(function(m){
          var specs=[]; if(m.series) specs.push(m.series); if(m.size_inch) specs.push(parseFloat(m.size_inch)+'"'); if(m.year) specs.push(m.year);
          return '<button type="button" class="fn-ddi" data-ref="'+esc(m.ref)+'">'
            + (m.image_url ? '<img class="fn-ddi-img" src="'+esc(_mediaUrl(m.image_url))+'" alt="" onerror="this.style.display=\'none\'">' : '')
            + '<span class="fn-ddi-n">'+esc(m.name)+'</span>'+(specs.length?'<span class="fn-ddi-s"> · '+esc(specs.join(' · '))+'</span>':'')+'</button>';
        }).join('');
        dd.style.display='block';
        if(window.Suchebene) window.Suchebene.messen();
      })
      .catch(function(e){
        if(q !== lastQ[i] || !dd) return;

        if(ausfall(e)){
          dd.innerHTML = '<div class="fn-ddi fn-ddi--aus">'
            + window.EngineStatus.hinweisHtml(
                T.sucheAus,
                WA_TEXT)
            + '</div>';
          dd.style.display='block';
          return;
        }
        dd.style.display='none';
      });
  }

  function loadMonitor(ref){
    return Promise.all([
      abruf(PROXY+'/monitors/'+ref),

      abruf(PROXY+'/monitors/'+ref+'/compatibility'+vesaQuery(ref))
    ]).then(function(res){
      var mon=res[0], compat=res[1];
      if(!mon.ok) return null;
      var m=mon.data, specs=[];
      if(m.size_inch) specs.push(parseFloat(m.size_inch)+'"');
      if(m.resolution_width && m.resolution_height) specs.push(m.resolution_width+'×'+m.resolution_height);
      if(m.weight_g) specs.push((m.weight_g/1000).toFixed(1)+' kg');
      return { ref:m.ref, name:m.name, specs:specs.join(' · '), image_url:m.image_url||null,
               weightG: m.weight_g || null,

               vesa: m.vesa || null,
               recommendations: (compat.ok && compat.data.recommendations) || [] };
    }).catch(function(){ return null; });
  }

  function selectMonitor(i, ref){
    return loadMonitor(ref).then(function(mo){
      if(!mo || !state.slots[i]) return;
      delete state.slots[i].__bearb;
      state.slots[i].monitor = mo;
      renderSlots();
      saveState();
      maybeRefresh();
    });
  }

  function maybeRefresh(){
    if(filledMonitors().length) runFinder();
    else resetFinder();
  }

  function duplicateSlot(i){
    if(state.slots.length >= MAX_MON) return;
    var src = state.slots[i].monitor; if(!src) return;
    state.slots.push({ monitor: JSON.parse(JSON.stringify(src)) });
    renderSlots();
    saveState();
    maybeRefresh();
  }
  function removeSlot(i){

    if(state.slots.length <= 1 && state.slots[i] && state.slots[i].monitor) return ersetzenSlot(i);
    state.slots.splice(i,1);
    if(!state.slots.length) state.slots.push({ monitor:null });
    renderSlots();
    saveState();
    maybeRefresh();
  }

  function ersetzenSlot(i){
    if(!state.slots[i] || !state.slots[i].monitor) return;

    state.slots[i].__bearb = true;
    renderSlots();
    var feld = slotsWrap.querySelector('.fn-slot[data-slot="' + i + '"] .fn-slot-inp');
    if(feld) feld.focus();
  }

  function ersetzenAbbrechen(i){
    if(!state.slots[i] || !state.slots[i].__bearb) return;

    if(window.Suchebene && window.Suchebene.zu) window.Suchebene.zu();
    delete state.slots[i].__bearb;
    renderSlots();
  }
  var addBtn = $('#fn-addmon');
  if(addBtn) addBtn.addEventListener('click', function(){
    if(state.slots.length >= MAX_MON) return;
    state.slots.push({ monitor:null });
    renderSlots();

    var inputs = slotsWrap.querySelectorAll('.fn-slot-inp');
    if(inputs.length) inputs[inputs.length-1].focus();
  });

  var mountGroup = $('[data-fn-group="mount"]');
  var deskField = $('[data-fn-desk]');
  var deskSel = $('[data-fn-deskselect]'), thickInp = $('[data-fn-thick]'), thickUnk = $('[data-fn-thick-unknown]'), deskRm = $('[data-fn-desk-rm]');
  function deskRmZeigen(){ if(deskRm) deskRm.hidden = !(state.deskType || state.thick || state.thickUnknown); }
  if(mountGroup){
    mountGroup.addEventListener('click', function(e){
      var c=e.target.closest('.fn-choice'); if(!c) return;
      this.querySelectorAll('.fn-choice').forEach(function(x){ x.classList.toggle('is-sel', x===c); });
      state.mount=c.getAttribute('data-value')||''; state.mountKey=c.getAttribute('data-mount-key')||'';
      saveState();
      maybeRefresh();
    });
  }
  if(deskSel) deskSel.addEventListener('change', function(){ state.deskType=this.value; deskRmZeigen(); saveState(); maybeRefresh(); });
  if(deskRm) deskRm.addEventListener('click', function(){ state.deskType=''; state.thick=''; state.thickUnknown=false; if(deskSel) deskSel.selectedIndex=0; if(thickInp){ thickInp.value=''; thickInp.disabled=false; } if(thickUnk) thickUnk.classList.remove('is-on'); deskRmZeigen(); saveState(); maybeRefresh(); if(deskSel) deskSel.focus(); });
  deskRmZeigen();
  if(thickInp) thickInp.addEventListener('input', function(){ state.thick=this.value; state.thickUnknown=false; if(thickUnk) thickUnk.classList.remove('is-on'); deskRmZeigen(); saveState(); maybeRefresh(); });
  if(thickUnk) thickUnk.addEventListener('click', function(){ state.thickUnknown=!state.thickUnknown; this.classList.toggle('is-on', state.thickUnknown); if(thickInp){ thickInp.disabled=state.thickUnknown; if(state.thickUnknown){ thickInp.value=''; state.thick=''; } } saveState(); maybeRefresh(); });

  function monitorVesaUnknown(mo){
    if(!mo) return false;
    var v = mo.vesa;
    if(!v) return true;
    if(v.mount === 'NO') return false;
    return !v.patterns || !v.patterns.length;
  }

  function vesaRefs(){
    var seen = {}, out = [];
    filledMonitors().forEach(function(mo){
      if(!monitorVesaUnknown(mo) || seen[mo.ref]) return;
      seen[mo.ref] = true; out.push(mo.ref);
    });
    return out;
  }
  function vesaUnknown(){ return vesaRefs().length > 0; }

  function vesaFor(ref){
    if(!state.vesaBy[ref]) state.vesaBy[ref] = { pattern:'', otherPattern:'', recessed:'', shape:'' };
    return state.vesaBy[ref];
  }

  function vesaHasPattern(v){
    return v.pattern === '75x75' || v.pattern === '100x100' || v.pattern === 'other';
  }
  function vesaCompleteFor(ref){
    var v = vesaFor(ref);
    if(!v.pattern) return false;
    if(!vesaHasPattern(v)) return true;
    if(v.pattern === 'other' && !v.otherPattern) return false;
    if(!v.recessed) return false;
    if(v.recessed === 'yes' && !v.shape) return false;
    return true;
  }

  function vesaComplete(){ return vesaRefs().every(vesaCompleteFor); }

  function vesaAnswerParams(ref){
    var v = state.vesaBy[ref]; if(!v) return [];
    var out = [];
    var vp = (v.pattern === 'other') ? v.otherPattern : v.pattern;
    if(vp) out.push('vesa_pattern=' + encodeURIComponent(vp));
    if(v.recessed && v.recessed !== 'unknown') out.push('vesa_recessed=' + encodeURIComponent(v.recessed));
    if(v.shape) out.push('vesa_shape=' + encodeURIComponent(v.shape));
    return out;
  }

  function vesaQuery(ref){
    var p = (state.vesaBy[ref] && vesaCompleteFor(ref)) ? vesaAnswerParams(ref) : [];
    return p.length ? '?' + p.join('&') : '';
  }

  var recRun = {};
  function refreshRecommendations(ref){
    var my = (recRun[ref] = (recRun[ref] || 0) + 1);
    return abruf(PROXY+'/monitors/'+encodeURIComponent(ref)+'/compatibility'+vesaQuery(ref))
      .then(function(json){
        if(my !== recRun[ref]) return;
        if(!json.ok || !json.data) return;
        var recs = json.data.recommendations || [];

        state.slots.forEach(function(s){
          if(s.monitor && String(s.monitor.ref) === String(ref)) s.monitor.recommendations = recs;
        });
        saveState();
      })
      .catch(function(){});
  }

  var vesaLogged = {};
  function reportVesaAnswer(ref){
    var p = vesaAnswerParams(ref);
    if(!p.length) return;
    var sig = p.join('&');
    if(vesaLogged[ref] === sig) return;
    vesaLogged[ref] = sig;
    fetch(PROXY+'/funnel/vesa-answer?m='+encodeURIComponent(ref)+'&'+sig).catch(function(){});
  }

  function vesaAnswered(ref){
    reportVesaAnswer(ref);
    refreshRecommendations(ref).then(maybeRefresh);
  }

  function vesaGateActive(){
    return filledMonitors().length > 0 && !vesaComplete();
  }

  var vesaTpl = $('[data-role="vesa-template"]');

  var vesaOpenSlots = {};

  document.addEventListener('click', function(e){
    var b = e.target.closest('.fn-vesa[data-vesa-ref] .fn-choice'); if(!b) return;
    var grp = b.closest('[data-fn-vesa]'); if(!grp) return;
    var ref = b.closest('.fn-vesa[data-vesa-ref]').getAttribute('data-vesa-ref');
    var v = vesaFor(ref);
    v[grp.getAttribute('data-fn-vesa')] = b.getAttribute('data-value') || '';

    if(v.pattern !== 'other') v.otherPattern = '';
    if(!vesaHasPattern(v)){ v.recessed=''; v.shape=''; }
    if(v.recessed !== 'yes') v.shape = '';
    saveState();
    var done = vesaCompleteFor(ref);
    if(done) closeVesaModal();

    renderSlots();

    if(done) vesaAnswered(ref); else maybeRefresh();
  });

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-role="vesa-info-toggle"]'); if(!t) return;
    var q = t.closest('.fn-vesa-q'); if(!q) return;
    var box = q.querySelector('.fn-vesa-info-box'); if(!box) return;
    var open = !box.hasAttribute('hidden');
    if(open) box.setAttribute('hidden', ''); else box.removeAttribute('hidden');
    t.setAttribute('aria-expanded', String(!open));
  });
  document.addEventListener('change', function(e){
    if(!e.target.matches('.fn-vesa[data-vesa-ref] [data-fn-vesa-other]')) return;
    var ref = e.target.closest('.fn-vesa[data-vesa-ref]').getAttribute('data-vesa-ref');
    vesaFor(ref).otherPattern = e.target.value || '';
    saveState();
    var done = vesaCompleteFor(ref);
    if(done) closeVesaModal();
    renderSlots();
    if(done) vesaAnswered(ref); else maybeRefresh();
  });

  var vesaOverlay = $('[data-role="vesa-overlay"]');
  var vesaSlot    = $('[data-role="vesa-slot"]');
  var vesaModalSeen = {};

  var vesaCloseBtn = $('[data-role="vesa-close"]');
  if(vesaCloseBtn) vesaCloseBtn.addEventListener('click', closeVesaModal);
  if(vesaOverlay) vesaOverlay.addEventListener('click', function(e){ if(e.target === vesaOverlay) closeVesaModal(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeVesaModal(); });

  var restartBtn = $('#fn-restart');
  if(restartBtn) restartBtn.addEventListener('click', resetFinder);

  function clearResults(){
    var req = $('[data-role="required"]'); if(req) req.style.display='none';

    var reqBody = $('[data-role="required-body"]'); if(reqBody) reqBody.innerHTML='';
    var oneWrap = $('[data-role="one-wrap"]'); if(oneWrap) oneWrap.style.display='none';
    var oneHead = $('[data-role="one-head"]'); if(oneHead) oneHead.style.display='none';
    var one = $('[data-role="one-section"]'); if(one) one.style.display='none';
    var mountWrap = $('[data-role="mount-groups"]'); if(mountWrap) mountWrap.innerHTML='';
    var empty = $('[data-role="halterung-empty"]'); if(empty) empty.style.display='none';
    var opt = $('[data-role="optional"]'); if(opt) opt.style.display='none';
    var grid = $('[data-role="presets"]'); if(grid) grid.innerHTML='';
    var moreWrap = $('[data-role="more"]'); if(moreWrap){ moreWrap.style.display='none'; moreWrap.innerHTML=''; }

    closeVesaModal();
    root.__redrawPresets = null;
    setSummaryEmpty();

    satzBauen();
  }

  function resetFinder(){
    finderRun++; funnelRun++;
    state.slots=[{ monitor:null }];
    state.presets=[]; state.required=[]; state.optional=[]; state.optionalRules=[]; state.optionalFunnel=[];
    state.selPreset=null; state.optOn={}; state.reqOn={}; state.reqAus={}; state.vesaOk=null;

    state.mount=''; state.mountKey=''; state.deskType=''; state.thick=''; state.thickUnknown=false;
    state.vesaBy = {};
    vesaModalSeen = {};
    closeVesaModal();
    if(mountGroup) mountGroup.querySelectorAll('.fn-choice').forEach(function(c){ c.classList.remove('is-sel'); });
    if(deskSel) deskSel.selectedIndex = 0;
    if(thickInp){ thickInp.value=''; thickInp.disabled=false; }
    if(thickUnk) thickUnk.classList.remove('is-on');
    deskRmZeigen();
    hasAutoScrolled = false;
    renderSlots();
    clearResults();
    updateActiveState();
    clearState();
    window.scrollTo({top: root.getBoundingClientRect().top + window.scrollY - 20, behavior:'smooth'});
  }

  function runFinder(){
    var mons = filledMonitors();
    if(!mons.length) return;
    updateActiveState();
    saveState();

    var vesaGapRefs = vesaRefs();
    if(!vesaGapRefs.length) closeVesaModal();
    if(!vesaComplete()){ showVesaGate(); return; }
    var main = $('#fn-result');
    var presetsBox = $('[data-role="presets"]');
    presetsBox.innerHTML = '<div class="fn-loading">'+esc(T.loading)+'</div>';

    var mWrapReset = $('[data-role="mount-groups"]'); if(mWrapReset) mWrapReset.innerHTML='';
    setSummaryEmpty();

    state.selPreset = null;

    if(main && !hasAutoScrolled){ hasAutoScrolled = true; main.scrollIntoView({behavior:'smooth', block:'start'}); }

    var qs = mons.map(function(m){ return 'm='+encodeURIComponent(m.ref); }).join('&');

    if(state.thick && !state.thickUnknown){
      qs += '&table_thickness_mm=' + encodeURIComponent(parseFloat(state.thick) * 10);
    }

    vesaGapRefs.forEach(function(ref){
      var v = vesaFor(ref), pre = encodeURIComponent(ref) + ':';
      var vp = (v.pattern === 'other') ? v.otherPattern : v.pattern;
      if(vp) qs += '&vesa_pattern=' + pre + encodeURIComponent(vp);
      if(v.recessed && v.recessed !== 'unknown') qs += '&vesa_recessed=' + pre + encodeURIComponent(v.recessed);
      if(v.shape) qs += '&vesa_shape=' + pre + encodeURIComponent(v.shape);
    });
    var myRun = ++finderRun;
    abruf(PROXY+'/combinations/compatible?'+qs)
      .then(function(json){
        if(myRun !== finderRun) return;
        if(!json.ok){ showHalterungFallback(); return; }
        var data=json.data;
        state.vesaOk = data.vesa_compatible;

        var combos = data.combinations || [];

        var ORDER=['REQUIRED','RECOMMENDED','OPTIONAL'];
        var reqCount={}, reqMeta={}, recMap={};
        mons.forEach(function(mon){
          (mon.recommendations||[]).forEach(function(rec){
            (rec.products||[]).forEach(function(p){
              var key=p.shopify_sku||p.sku;
              if(!key) return;

              var liegtBei = !!rec.oem_supplied;
              if(rec.requirement==='REQUIRED'){
                reqCount[key]=(reqCount[key]||0)+1;
                if(!reqMeta[key]) reqMeta[key]={product:p, message:rec.message, slots:[], altGroup:rec.alt_group||null, liegtBei:liegtBei};
                else reqMeta[key].liegtBei = reqMeta[key].liegtBei && liegtBei;

                if(reqMeta[key].slots.indexOf(mon.slotIndex) < 0) reqMeta[key].slots.push(mon.slotIndex);
              } else {
                if(!recMap[key]) recMap[key]={product:p, requirement:rec.requirement, message:rec.message, sku:key, slots:[], altGroup:rec.alt_group||null, liegtBei:liegtBei};
                else if(ORDER.indexOf(rec.requirement)<ORDER.indexOf(recMap[key].requirement)) recMap[key]={product:p, requirement:rec.requirement, message:rec.message, sku:key, slots:recMap[key].slots, altGroup:rec.alt_group||null, liegtBei:recMap[key].liegtBei && liegtBei};
                else recMap[key].liegtBei = recMap[key].liegtBei && liegtBei;
                if(recMap[key].slots.indexOf(mon.slotIndex) < 0) recMap[key].slots.push(mon.slotIndex);
              }
            });
          });
        });

        Object.keys(reqCount).forEach(function(k){ delete recMap[k]; });
        var reqItems=Object.keys(reqCount).map(function(k){ return {product:reqMeta[k].product, message:reqMeta[k].message, qty:reqCount[k], requirement:'REQUIRED', sku:k, slots:reqMeta[k].slots, altGroup:reqMeta[k].altGroup, liegtBei:reqMeta[k].liegtBei}; });

        Object.keys(recMap).forEach(function(k){
          if(recMap[k].requirement==='RECOMMENDED'){
            reqItems.push({product:recMap[k].product, message:recMap[k].message, qty:1, requirement:'RECOMMENDED', sku:k, slots:recMap[k].slots, altGroup:recMap[k].altGroup, liegtBei:recMap[k].liegtBei});
            delete recMap[k];
          }
        });
        var recItems=Object.keys(recMap).map(function(k){return recMap[k];});
        recItems.sort(function(a,b){return ORDER.indexOf(a.requirement)-ORDER.indexOf(b.requirement);});

        var comboLk=combos.map(function(c){ return _spLookup((c.product&&c.product.shopify_sku)||c.sku||null, (c.product&&c.product.handle)||null); });
        var reqLk=reqItems.map(function(a){ return _spLookup(a.product.shopify_sku||a.product.sku, a.product.handle||null); });
        var recLk=recItems.map(function(a){ return _spLookup(a.product.shopify_sku||a.product.sku, a.product.handle||null); });

        var plateLk=combos.map(function(c){
          var r=(c.fit==='bundle'&&c.requires&&c.requires[0])?c.requires[0]:null;
          if(!r) return Promise.resolve(null);
          var pc=r.product||null;
          var rsku=(pc&&pc.shopify_sku)||r.shopify_sku||r.sku;
          var rhandle=(pc&&pc.handle)||r.handle||null;
          return _spLookup(rsku, rhandle);
        });
        var plateBase = combos.length + reqItems.length + recItems.length;

        Promise.all(comboLk.concat(reqLk, recLk, plateLk)).then(function(sp){
          if(myRun !== finderRun) return;

          state.presets = combos.map(function(c,i){ return { sp: sp[i], kind: c.kind||'one', empfehlung: c.empfehlung||null, sku: (c.product&&c.product.shopify_sku)||c.sku||'', weightKg: c.weight_kg, setupKg: c.setup_weight_kg, traglast: c.traglast||null, traglastHinweis: c.traglast_hinweis||null, armCount: c.monitors||0, mountType: c.mount_type||'', fit: c.fit||'direct', requires: c.requires||[], requiresSp: (c.fit==='bundle'&&c.requires&&c.requires[0]) ? sp[plateBase+i] : null }; });
          state.presets.forEach(function(x){

            if(!x.sp) console.warn('[finder] Kein Shopify-Produkt zur Engine-Antwort gefunden — SKU:', x.sku || '(keine)', '/ kind:', x.kind);
          });
          state.presets = state.presets.filter(function(x){ return !!x.sp; });

          state.presets = state.presets.filter(function(x){ return x.kind!=='mount'; })
                    .concat(state.presets.filter(function(x){ return x.kind==='mount'; }));

          state.required = reqItems.map(function(a,i){ return { sp: sp[combos.length+i], message:a.message, qty:a.qty, product:a.product, requirement:a.requirement, sku:a.sku, slots:a.slots||[], altGroup:a.altGroup||null, liegtBei:!!a.liegtBei }; });
          state.optionalRules = recItems.map(function(a,i){ return { sp: sp[combos.length+reqItems.length+i], requirement:a.requirement, message:a.message, sku:a.sku }; }).filter(function(x){ return x.sp; });
          state.optionalFunnel = [];
          state.reqOn = {};
          pflichtVorwaehlen();
          rebuildOptional();

          if(!state.presets.length && !state.required.length){ showHalterungFallback(); return; }

          renderRequired();
          renderPresets();
          renderOptional();
          renderSummary();

          if(wunschPreset){
            var wp = String(wunschPreset); wunschPreset = null;
            state.presets.some(function(x, i){
              if(String(x.sku || '') !== wp) return false;
              selectPreset(i);
              renderPresets();
              return true;
            });
          }
                loadPresetMeta();
        });
      })
      .catch(function(e){ if(myRun === finderRun) showHalterungFallback(ausfall(e)); });
  }

  function montageContext(){

    if(state.mountKey==='wall') return 'wall';
    if(state.mountKey==='desk') return 'desk';
    var types = (state.presets||[]).map(function(p){ return p.mountType||''; }).filter(Boolean);
    if(types.length){
      if(types.every(function(t){ return t.indexOf('wand')===0; })) return 'wall';
      if(types.every(function(t){ return t==='tischhalterung'; }))  return 'desk';
      return null;
    }
    return null;
  }
  function rebuildOptional(){
    var have = {};
    state.required.forEach(function(x){ if(x.sku) have[String(x.sku).toUpperCase()] = true; });
    var list = [];
    (state.optionalRules||[]).concat(state.optionalFunnel||[]).forEach(function(x){
      var key = x.sku ? String(x.sku).toUpperCase() : null;
      if(key){ if(have[key]) return; have[key] = true; }
      list.push(x);
    });
    var ctx = montageContext();

    var staticOrdered = STATIC_ZUBEHOER.filter(function(i){ return (i.scope||'all')!=='all'; })
                  .concat(STATIC_ZUBEHOER.filter(function(i){ return (i.scope||'all')==='all'; }));
    staticOrdered.forEach(function(item){
      if(!item.sku || !item.variant_id) return;

      var scope = item.scope || 'all';
      if(scope !== 'all' && ctx && scope !== ctx) return;
      var key = String(item.sku).toUpperCase();
      if(have[key]) return;
      have[key] = true;
      list.push({
        sp: { title:item.title, url:item.url, image:item.image, price:item.price, variant_id:item.variant_id, available:item.available },
        requirement: 'OPTIONAL',

        message: item.description || '',
        sku: item.sku,
        static: true,

        scope: scope
      });
    });
    state.optional = list;

    var validVids = {};
    state.optional.forEach(function(x){ if(x.sp && x.sp.variant_id) validVids[x.sp.variant_id] = true; });
    Object.keys(state.optOn).forEach(function(vid){ if(!validVids[vid]) delete state.optOn[vid]; });
  }

  function vesaOpenMonitors(){
    return filledMonitors().filter(function(m){
      if(!monitorVesaUnknown(m)) return false;
      return (state.vesaBy[m.ref] || {}).pattern === 'none';
    });
  }

  function monitorOhneStandard(m){
    var v = m && m.vesa;
    if(!v || v.mount !== 'NO') return false;
    return !state.required.some(function(e){
      return (e.slots || []).indexOf(m.slotIndex) > -1;
    });
  }

  function sonderloesungMonitore(){
    var seen = {}, out = [];
    vesaOpenMonitors()
      .concat(filledMonitors().filter(monitorOhneStandard))
      .forEach(function(m){ if(!seen[m.ref]){ seen[m.ref] = true; out.push(m); } });
    return out;
  }

  function _requiredAllDone(){
    return state.required.every(function(x){ return !x.sp || !x.sp.available || _reqCovered(x); });
  }

  function _requiredTierAllDone(){
    return state.required.every(function(x){ return x.requirement!=='REQUIRED' || x.liegtBei || !x.sp || !x.sp.available || _reqCovered(x); });
  }

  function selectPreset(idx){
    var turningOn = state.selPreset!==idx;
    state.selPreset = (state.selPreset===idx) ? null : idx;
    if(root.__redrawPresets) root.__redrawPresets();
    hidePostAdd();
    _updateAtcMedia();
    renderSummary();

    maybeEvaluateFunnelRules(null);

    saveState();
  }

  function maybeEvaluateFunnelRules(done){

    var priorFunnelSkus = state.required.filter(function(x){ return x.fromFunnel && x.sku; })
                                        .map(function(x){ return x.sku; });
    state.required = state.required.filter(function(x){ return !x.fromFunnel; });
    state.optionalFunnel = [];

    function finish(){
      var stillThere = {};
      state.required.forEach(function(x){ if(x.fromFunnel && x.sku) stillThere[x.sku] = true; });
      priorFunnelSkus.forEach(function(sku){ if(!stillThere[sku]) delete state.reqOn[sku]; });
      pflichtVorwaehlen();
      rebuildOptional(); renderRequired(); renderOptional(); renderSummary();

      satzBauen();
      if(typeof done === 'function') done();
    }

    var preset = state.selPreset!=null ? state.presets[state.selPreset] : null;

    var isDeskSetup = state.mountKey==='desk' || (preset && preset.mountType==='tischhalterung');

    if(!preset){ finish(); return; }

    var qs = [];

    var plateReq = (preset.fit==='bundle' && preset.requires && preset.requires[0]) ? preset.requires[0] : null;
    if(preset.sku)          qs.push('mount_sku=' + encodeURIComponent(preset.sku));
    if(plateReq && plateReq.sku) qs.push('vesa_plate_sku=' + encodeURIComponent(plateReq.sku));

    if(isDeskSetup && (preset.setupKg!=null || preset.weightKg!=null)){
      var monitorsKg = filledMonitors().reduce(function(sum, m){ return sum + (m.weightG ? m.weightG/1000 : 0); }, 0);
      var totalKg = preset.setupKg!=null ? parseFloat(preset.setupKg) : monitorsKg + parseFloat(preset.weightKg);
      qs.push('setup_total_weight_kg=' + encodeURIComponent(totalKg.toFixed(2)));

      var dickeCm = (state.thick && !state.thickUnknown) ? parseFloat(state.thick) : null;
      var material = deskMaterial(state.deskType, dickeCm);
      if(material) qs.push('table_material=' + encodeURIComponent(material));
    }
    if(!qs.length){ finish(); return; }

    var myRun = ++funnelRun;
    abruf(PROXY + '/funnel/recommendations?' + qs.join('&'))
      .then(function(json){
        if(myRun !== funnelRun) return;

        var recs = (json.ok && json.data && json.data.recommendations) || [];
        if(!recs.length){ finish(); return; }
        return Promise.all(recs.map(function(rec){

          var p = rec.products && rec.products[0];
          if(!p) return null;
          return _spLookup(p.shopify_sku || p.sku, p.handle)
            .then(function(sp){ return sp ? { rec:rec, p:p, sp:sp } : null; })
            .catch(function(){ return null; });
        })).then(function(hits){
          if(myRun !== funnelRun) return;
          hits.forEach(function(h){
            if(!h) return;
            var pSku = h.p.shopify_sku || h.p.sku;

            var isPlate = !!(plateReq && plateReq.sku && [h.p.sku, h.p.shopify_sku].some(function(s){
              return s && String(s).toLowerCase() === String(plateReq.sku).toLowerCase();
            }));
            var qty = isPlate ? (plateReq.qty || 1) : 1;

            if(h.rec.requirement==='REQUIRED' || h.rec.requirement==='RECOMMENDED'){

              state.required.push({ sp:h.sp, message:h.rec.message, qty:qty, product:h.p, fromFunnel:true, requirement:h.rec.requirement, sku:pSku, slots:[], altGroup:h.rec.alt_group||null, liegtBei:!!h.rec.oem_supplied,

                istVesaPlatte: isPlate });
            } else {
              state.optionalFunnel.push({ sp:h.sp, requirement:h.rec.requirement, message:h.rec.message, fromFunnel:true, sku:pSku });
            }
          });
          finish();
        });
      })
      .catch(function(){ finish(); });
  }

  function setText(sel,v){ var e=$(sel); if(e) e.textContent=v; }
  function disable(sel,on){ var e=$(sel); if(e) e.disabled=!!on; }

  function pflichtVorwaehlen(){
    state.required.forEach(function(x){
      if(x.requirement !== 'REQUIRED' || !x.sku) return;
      if(state.reqAus[x.sku]) return;
      if(!x.sp || !x.sp.variant_id || !x.sp.available) return;
      state.reqOn[x.sku] = true;
    });
  }

  function _reqIncluded(x){ return !!state.reqOn[x.sku]; }

  function _altGroupPicked(g){
    if(!g) return false;
    return state.required.some(function(x){ return x.altGroup===g && _reqIncluded(x); });
  }

  function _reqCovered(x){ return _reqIncluded(x) || _altGroupPicked(x.altGroup); }

  function _selectedPlate(){
    if(state.selPreset==null) return null;
    var p=state.presets[state.selPreset];
    return (p && p.fit==='bundle' && p.requiresSp) ? p.requiresSp : null;
  }

  function _zeilenMonitore(x){
    var namen = [], gesehen = {};
    (x.slots || []).forEach(function(si){
      var m = state.slots[si] && state.slots[si].monitor;
      if(!m || !m.name || gesehen[m.ref]) return;
      gesehen[m.ref] = true; namen.push(m.name);
    });
    return namen;
  }

  function _istMto(sp){ return !!(sp && sp.tags && sp.tags.indexOf('mto') >= 0); }

  var _rabattWartet = {}; var _rabattVersuche = {};
  function _rabattFuer(sp){
    var h = _handleFromUrl(sp && sp.url);
    if(!h) return null;
    if(_metaCache.hasOwnProperty(h)) return (_metaCache[h] && _metaCache[h].rabatt) || null;
    if(!_rabattWartet[h]){
      _rabattWartet[h] = true;
      _meta(h).then(function(){
        if(!_metaCache.hasOwnProperty(h) && (_rabattVersuche[h] = (_rabattVersuche[h] || 0) + 1) <= 3){
          setTimeout(function(){ _rabattWartet[h] = false; renderSummary(); }, 1500 * _rabattVersuche[h]);
          return;
        }
        renderSummary();
      });
    }
    return null;
  }
  function summaryItems(){
    var items=[];
    state.required.forEach(function(x){ if(!_reqIncluded(x)) return; items.push({ title:x.sp.title, label:T.summaryRequiredLabel, price:x.sp.price, qty:x.qty||1, vid:x.sp.variant_id, available:x.sp.available, mto:_istMto(x.sp), preorder:!!x.sp.preorder, rabatt:_rabattFuer(x.sp),

    art:(x.product && x.product.type) || '', geraete:_zeilenMonitore(x) }); });

    if(state.selPreset!=null){ var pr=state.presets[state.selPreset], s=pr.sp; items.push({ title:s.title, label:T.presetLabel, price:s.price, qty:1, vid:s.variant_id, available:s.available, mto:_istMto(s), preorder:!!s.preorder || !!(pr.meta && pr.meta.vorbestellung), rabatt:(pr.meta && pr.meta.rabatt) || null }); }

    Object.keys(state.optOn).forEach(function(vid){ var s=state.optional[state.optOn[vid]].sp; items.push({ title:s.title, label:T.optionalLabel, price:s.price, qty:1, vid:s.variant_id, available:s.available, mto:_istMto(s), preorder:!!s.preorder, rabatt:_rabattFuer(s) }); });
    return items;
  }

  function _waSetupText(){
    var L = [];
    L.push(T.waIntro, '');
    L.push(T.waMonitors + ':');
    var seen = {};
    filledMonitors().forEach(function(m){
      if(seen[m.ref]) { seen[m.ref]++; return; }
      seen[m.ref] = 1;
    });
    var done = {};
    filledMonitors().forEach(function(m){
      if(done[m.ref]) return;
      done[m.ref] = true;
      var p = (state.vesaBy[m.ref] || {}).pattern;
      var note = (p === 'none') ? ' (' + T.waNoteNone + ')' : '';
      var qty = seen[m.ref] > 1 ? seen[m.ref] + '× ' : '';
      L.push('- ' + qty + m.name + note);
    });
    if(state.mount) L.push('', T.waMount + ': ' + state.mount);
    var items = summaryItems();
    if(items.length){
      L.push('', T.waSelection + ':');
      var sum = 0;
      items.forEach(function(it){
        var q = it.qty || 1;
        sum += (it.price || 0) * q;
        L.push('- ' + (q > 1 ? q + '× ' : '') + it.title + (it.price != null ? ' — ' + _price(it.price * q) : ''));
      });
      L.push(T.waTotal + ': ' + _price(sum));
    }
    L.push('', location.href);
    return L.join('\n');
  }

  function _waLinkWithSetup(){
    if(!T.waLink) return '';
    return T.waLink.split('?')[0] + '?text=' + encodeURIComponent(_waSetupText());
  }

  function _adapterQty(){
    return state.required.reduce(function(sum,x){
      if(x.sp && x.sp.available && x.sp.variant_id && x.product && x.product.type==='ADAPTER' && _reqIncluded(x)) return sum+(x.qty||1);
      return sum;
    }, 0);
  }

  function _potentialAdapterQty(){
    return state.required.reduce(function(sum,x){
      if(x.sp && x.sp.available && x.sp.variant_id && x.product && x.product.type==='ADAPTER') return sum+(x.qty||1);
      return sum;
    }, 0);
  }

  function _bundleUnits(armCount){
    return Math.min(_adapterQty(), armCount||0);
  }

  function _bundleUnitsPotential(armCount){
    return Math.min(_potentialAdapterQty(), armCount||0);
  }

  function bundleBisZuCents(){
    var best = 0;
    state.presets.forEach(function(p){
      var tags = (p.sp && p.sp.tags) || [];
      var betrag = p.kind === 'mount' ? (tags.indexOf('mount') >= 0 ? BUNDLE_AMOUNT_FLEXI : 0) : BUNDLE_AMOUNT;
      if(p.kind === 'mount' && betrag > 0 && BUNDLE_FLEXI_AB > 0 && p.sp
         && (p.sp.price || 0) / (p.armCount || 1) >= BUNDLE_FLEXI_AB * 100) betrag = BUNDLE_AMOUNT_FLEXI_HOCH;
      if(betrag <= 0) return;
      var c = Math.round(_bundleUnits(p.armCount) * betrag * 100);
      if(c > best) best = c;
    });
    return best;
  }
  function bundleDiscountCents(){
    if(state.selPreset==null) return 0;
    var preset = state.presets[state.selPreset];

    var tags = (preset.sp && preset.sp.tags) || [];
    var betrag = preset.kind === 'mount'
      ? (tags.indexOf('mount') >= 0 ? BUNDLE_AMOUNT_FLEXI : 0)
      : BUNDLE_AMOUNT;

    if(preset.kind === 'mount' && betrag > 0 && BUNDLE_FLEXI_AB > 0 && preset.sp
       && (preset.sp.price || 0) / (preset.armCount || 1) >= BUNDLE_FLEXI_AB * 100){
      betrag = BUNDLE_AMOUNT_FLEXI_HOCH;
    }
    if(betrag<=0) return 0;
    return Math.round(_bundleUnits(preset.armCount)*betrag*100);
  }

  var postAddRestartBtn=$('[data-role="postadd-restart"]');
  if(postAddRestartBtn) postAddRestartBtn.addEventListener('click', resetFinder);

  function _updateAtcMedia(){
    var btn = $('[data-role="cta-add"]');
    var container = btn ? btn.closest('add-to-cart-component') : null;
    if(!container) return;
    var img = (state.selPreset!=null && state.presets[state.selPreset].sp.image) || '';
    container.setAttribute('data-product-variant-media', img);
  }

  function addComplete(btn){
    var ids=[];
    state.required.forEach(function(x){ if(_reqIncluded(x) && x.sp.available && x.sp.variant_id) ids.push({id:x.sp.variant_id, quantity:x.qty||1, selling_plan:x.sp.selling_plan_id}); });
    if(state.selPreset!=null){ var preset=state.presets[state.selPreset], ps=preset.sp; if(ps.variant_id) ids.push({id:ps.variant_id, quantity:1, selling_plan:ps.selling_plan_id}); }

    Object.keys(state.optOn).forEach(function(vid){ var s=state.optional[state.optOn[vid]].sp; if(s.available && s.variant_id) ids.push({id:s.variant_id, quantity:1, selling_plan:s.selling_plan_id}); });
    if(!ids.length) return;
    var textEl = btn.querySelector('.add-to-cart-text__content');
    btn.disabled=true;
    _cartAdd(ids, function(ok, err){
      btn.disabled=false;
      if(ok){
        renderSummary();
        showPostAdd();
      }
      else if(textEl){
        var original = textEl.textContent;
        textEl.textContent = '⚠ '+(err||T.fehler);
        setTimeout(function(){ textEl.textContent = original; }, 2500);
      }
    });
  }
  var ctaAdd=$('[data-role="cta-add"]'); if(ctaAdd) ctaAdd.addEventListener('click', function(){ addComplete(ctaAdd); });
  var drawerAdd=$('[data-role="drawer-add"]'); if(drawerAdd) drawerAdd.addEventListener('click', function(){ addComplete(drawerAdd); });

  function addRequiredOnly(btn){
    var ids=[];
    state.required.forEach(function(x){ if(_reqIncluded(x) && x.sp.available && x.sp.variant_id) ids.push({id:x.sp.variant_id, quantity:x.qty||1, selling_plan:x.sp.selling_plan_id}); });
    if(!ids.length) return;
    btn.disabled=true; var old=btn.textContent; btn.textContent='…';
    _cartAdd(ids, function(ok, err){
      btn.disabled=false;
      if(ok){
        btn.textContent=old;
        btn.classList.add('is-added');
        setTimeout(function(){ btn.classList.remove('is-added'); }, 900);
        renderSummary();
        showPostAdd();
      }
      else { btn.textContent='⚠ '+(err||T.fehler); setTimeout(function(){ btn.textContent=old; }, 2500); }
    });
  }
  $$('[data-role="cta-required"]').forEach(function(b){ b.addEventListener('click', function(){ addRequiredOnly(b); }); });

  function addHalterungOnly(btn){
    if(state.selPreset==null) return;
    var selP=state.presets[state.selPreset], ps=selP.sp;
    if(!ps.available || !ps.variant_id) return;

    if(selP.fit==='bundle' && !(selP.requiresSp && selP.requiresSp.available && selP.requiresSp.variant_id)) return;
    var ids=[{id:ps.variant_id, quantity:1, selling_plan:ps.selling_plan_id}];

    var plate=_selectedPlate();
    if(plate && plate.available && plate.variant_id) ids.push({id:plate.variant_id, quantity:1, selling_plan:plate.selling_plan_id});
    btn.disabled=true; var old=btn.textContent; btn.textContent='…';
    _cartAdd(ids, function(ok, err){
      btn.disabled=false;
      if(ok){
        btn.textContent=old;
        btn.classList.add('is-added');
        setTimeout(function(){ btn.classList.remove('is-added'); }, 900);
        renderSummary();
        showPostAdd();
      }
      else { btn.textContent='⚠ '+(err||T.fehler); setTimeout(function(){ btn.textContent=old; }, 2500); }
    });
  }
  $$('[data-role="cta-halterung"]').forEach(function(b){ b.addEventListener('click', function(){ addHalterungOnly(b); }); });

  var drawer=$('#fn-drawer');
  var openD=$('#fn-opendrawer'), closeD=$('#fn-closedrawer');
  if(openD) openD.addEventListener('click', function(){ if(drawer) drawer.classList.add('is-open'); });
  if(closeD) closeD.addEventListener('click', function(){ if(drawer) drawer.classList.remove('is-open'); });
  if(drawer) drawer.addEventListener('click', function(e){ if(e.target===drawer) drawer.classList.remove('is-open'); });

  function _collectText(children){
    return (children||[]).map(function(c){
      if(typeof c==='string') return c;
      if(c && c.type==='text') return c.value||'';
      if(c && c.children) return _collectText(c.children);
      return '';
    }).join('');
  }
  function _metaLines(val){
    if(val==null || val==='') return [];
    if(typeof val==='string') return val.split(/\r?\n/).map(function(s){return s.trim();}).filter(Boolean);
    if(Array.isArray(val)) return val.map(function(s){return String(s).trim();}).filter(Boolean);
    if(typeof val==='object'){
      var nodes = (val.type==='root' ? val.children : val.children) || [];
      var lines=[];
      nodes.forEach(function(node){
        if(!node) return;
        if(node.type==='list'){
          (node.children||[]).forEach(function(li){ var t=_collectText(li.children).trim(); if(t) lines.push(t); });
        } else {
          _collectText(node.children).split(/\r?\n/).forEach(function(x){ x=x.trim(); if(x) lines.push(x); });
        }
      });
      return lines;
    }
    return [];
  }
  function _metaPlain(val){ var l=_metaLines(val); return l.length ? l.join(' ') : ''; }

  var _metaCache={};
  function _handleFromUrl(u){ var m=/\/products\/([^/?#]+)/.exec(u||''); return m?m[1]:null; }
  function _meta(handle){
    if(!handle) return Promise.resolve(null);
    if(_metaCache.hasOwnProperty(handle)) return Promise.resolve(_metaCache[handle]);

    return _spFetch(ROOT+'products/'+handle+'?view=finder-meta')
      .then(function(j){ return (_metaCache[handle]=j); })
      .catch(function(){ return null; });
  }

  function loadPresetMeta(){
    if(!state.presets.length) return;
    var jobs=[];
    state.presets.forEach(function(p){
      if(p.meta===undefined) jobs.push(_meta(_handleFromUrl(p.sp.url)).then(function(m){ p.meta=m||null; }));

    });
    if(!jobs.length) return;
    Promise.all(jobs).then(function(){ if(root.__redrawPresets) root.__redrawPresets(); renderSummary(); });
  }

  var _spCache={};

  var _SP_MAX_PARALLEL = 6;
  var _spActive = 0, _spQueue = [];
  function _spSlot(){
    if(_spActive < _SP_MAX_PARALLEL){ _spActive++; return Promise.resolve(); }
    return new Promise(function(res){ _spQueue.push(res); });
  }
  function _spRelease(){
    var next = _spQueue.shift();
    if(next) next(); else _spActive--;
  }

  function _spFetch(url, tries){
    tries = (tries == null) ? 3 : tries;
    return _spSlot().then(function(){
      return fetch(url);
    }).then(function(r){
      if(r.status === 404) return null;
      if(!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function(v){
      _spRelease();
      return v;
    }, function(err){
      _spRelease();
      if(tries <= 1) throw err;

      return new Promise(function(res){ setTimeout(res, 400 * (4 - tries)); })
        .then(function(){ return _spFetch(url, tries - 1); });
    });
  }

  function _spPlan(p, v){
    var a = v && v.selling_plan_allocations && v.selling_plan_allocations[0];
    if(!a) return null;
    var name='';
    (p.selling_plan_groups||[]).forEach(function(g){
      (g.selling_plans||[]).forEach(function(sp){ if(sp.id===a.selling_plan_id) name=sp.name||''; });
    });
    return { id:a.selling_plan_id, name:name };
  }

  function _spShape(p, v){
    var plan = _spPlan(p, v);
    return {
      title:p.title, url:ROOT+'products/'+p.handle, image:p.featured_image,
      price:v.price, variant_id:v.id,
      available: v.available || !!plan,
      preorder: plan ? plan.name : null,
      selling_plan_id: plan ? plan.id : null,
      tags:p.tags||[], description:p.description||''
    };
  }

  function _spFromHandle(handle, sku){
    return _spFetch(ROOT+'products/'+handle+'.js').then(function(p){
      if(!p||!p.handle) return null;
      var su=(sku||'').toUpperCase(), v=null;
      for(var i=0;i<(p.variants||[]).length;i++){ if((p.variants[i].sku||'').toUpperCase()===su){ v=p.variants[i]; break; } }
      if(!v) return null;

      return _spShape(p, v);
    });
  }

  function _spBySkuSearch(sku){
    if(!sku) return Promise.resolve(null);
    return _spFetch(ROOT+'search/suggest.json?q='+encodeURIComponent(sku)+'&resources[type]=product&resources[limit]=5&resources[options][fields]=variants.sku')
      .then(function(data){
        var ps=(data&&data.resources&&data.resources.results&&data.resources.results.products)||[];
        function tryP(i){ if(i>=ps.length) return null; return _spFromHandle(ps[i].handle, sku).then(function(r){ return r || tryP(i+1); }); }
        return tryP(0);
      });
  }
  function _spLookup(sku, handle){
    if(!sku && !handle) return Promise.resolve(null);
    var key=(sku||'')+'|'+(handle||'');
    if(_spCache.hasOwnProperty(key)) return Promise.resolve(_spCache[key]);
    var p;

    if(handle){

      p = _spFromHandle(handle, sku).then(function(r){
        return r || _spBySkuSearch(sku);
      });
    } else {
      p = _spBySkuSearch(sku).then(function(r){
        if(r) return r;

        var h=String(sku||'').toLowerCase().replace(/[^a-z0-9]+/g,'-');
        return h ? _spFromHandle(h, sku) : null;
      });
    }

    return p.then(function(r){ return (_spCache[key]=r); }, function(err){
      console.warn('[finder] Shop-Abfrage fehlgeschlagen (wird nicht gemerkt) — SKU:',
                   sku || '(keine)', '/ Handle:', handle || '(keiner)', err);
      return null;
    });
  }

  function _cartAdd(list, done){

    if(typeof window.WarenkorbLegen !== 'function'){ if(done) done(false,T.korbNichtBereit); return; }

    var dazu = (list || []).reduce(function(s, x){
      return s + ((x && typeof x === 'object') ? (x.quantity || 1) : (x ? 1 : 0));
    }, 0);
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { '_finder': 'z' + ((c.item_count || 0) + dazu) } })
        });
      }).catch(function(){})
      .then(function(){ window.WarenkorbLegen(list, done); });
  }

  A = (typeof window.FinderAnsicht === 'function')
    ? (window.FinderAnsicht({
        $: $,
        $$: $$,
        BUNDLE_AMOUNT: BUNDLE_AMOUNT,
        BUNDLE_TITEL: BUNDLE_TITEL,
        MAX_MON: MAX_MON,
        SEARCH_SVG: SEARCH_SVG,
        T: T,
        _bundleUnits: _bundleUnits,
        _bundleUnitsPotential: _bundleUnitsPotential,
        _metaPlain: _metaPlain,
        S: S,
        _mediaUrl: _mediaUrl,
        _price: _price,
        _reqCovered: _reqCovered,
        _reqIncluded: _reqIncluded,
        _requiredTierAllDone: _requiredTierAllDone,
        _vesaAnswerSummary: _vesaAnswerSummary,
        _waLinkWithSetup: _waLinkWithSetup,
        bundleDiscountCents: bundleDiscountCents,
        bundleBisZuCents: bundleBisZuCents,
        d: d,
        disable: disable,
        esc: esc,
        filledMonitors: filledMonitors,
        monitorVesaUnknown: monitorVesaUnknown,
        restartBtn: restartBtn,
        root: root,
        selectPreset: selectPreset,
        setText: setText,
        slotsWrap: slotsWrap,
        sonderloesungMonitore: sonderloesungMonitore,
        state: state,
        summaryItems: summaryItems,
        vesaCompleteFor: vesaCompleteFor,
        vesaFor: vesaFor,
        vesaHasPattern: vesaHasPattern,
        vesaModalSeen: vesaModalSeen,
        vesaOpenSlots: vesaOpenSlots,
        vesaOverlay: vesaOverlay,
        vesaRefs: vesaRefs,
        vesaSlot: vesaSlot,
        vesaTpl: vesaTpl
      }) || {})
    : {};

  renderSlots();
  clearResults();
  updateActiveState();
  restoreState();

  window.FinderClean = window.FinderClean || {};
  window.FinderClean.proxy = PROXY;
  window.FinderClean.waehleMonitor = function(ref){
    if(!ref) return Promise.resolve();
    return selectMonitor(0, ref);
  };

  document.dispatchEvent(new CustomEvent('finder:bereit'));

  var ausAdresse = (location.search.match(/[?&]monitor=([^&]+)/) || [])[1];
  if (ausAdresse) {
    try {
      var sauber = location.pathname
        + location.search.replace(/([?&])monitor=[^&]*(&|$)/, '$1').replace(/[?&]$/, '')
        + location.hash;
      history.replaceState(null, '', sauber);
    } catch (e) {}

    var wieViele = parseInt((location.search.match(/[?&]anzahl=(\d+)/) || [])[1], 10);
    selectMonitor(0, decodeURIComponent(ausAdresse)).then(function(){
      if(!(wieViele > 1)) return;
      var zahl = Math.min(wieViele, MAX_MON);
      for(var i = 1; i < zahl; i++) duplicateSlot(0);
    });
  }
  var istAnfrage = root.getAttribute('data-anfrage') === '1';
  var anfrageGilt = istAnfrage && !document.documentElement.hasAttribute('data-anfrage-abgelaufen');
  var TIPPS = [
    { param: 'tp', wort: d.tTippPreis   || 'Preis-Tipp' },
    { param: 'tk', wort: d.tTippKomfort || 'Komfort-Tipp' },
    { param: 'tz', wort: d.tTippZukunft || 'Zukunfts-Tipp', beste: true }
  ];
  function presetIdx(sku){
    if(!sku) return -1;
    for(var i = 0; i < state.presets.length; i++) if(state.presets[i].sku === sku) return i;
    return -1;
  }
  function tippPreis(cents, m){
    var rab = m && m.rabatt, kr = 0;
    if(rab && Number(rab.wert) > 0) kr = rab.art === 'prozent' ? Math.round(cents * Number(rab.wert) / 100) : Math.round(Number(rab.wert) * 100);
    if(!(kr > 0 && kr < cents)) return _price(cents);
    return '<s class="fn-price-was">' + _price(cents) + '</s> <span class="vorteil-preis' + (rab.aktion ? ' vorteil-preis--aktion' : '') + '">' + _price(cents - kr) + '</span>';
  }
  var tippKasten = document.querySelector('[data-anfrage-tipps]');
  var tippStand = null;
  var nutzenCache = {};
  function tippNutzen(p){
    var h = p.sp && p.sp.url ? _handleFromUrl(p.sp.url) : '';
    if(!h) return '';
    if(nutzenCache.hasOwnProperty(h)) return nutzenCache[h] || '';
    nutzenCache[h] = '';
    new Promise(function(fertig){ setTimeout(fertig, 2500); })
      .then(function(){ return fetch(ROOT + 'products/' + encodeURIComponent(h), { credentials: 'same-origin' }); })
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        if(!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var n = doc.querySelector('.opv') || doc.querySelector('.one-nutzen');
        if(!n) return;
        n.querySelectorAll('.opv__konf, .opv__i, [data-fenster-auf]').forEach(function(x){ x.remove(); });
        {
          doc.querySelectorAll('link[rel="stylesheet"]').forEach(function(l){
            var href = l.getAttribute('href') || '';
            if(/one-(nutzen|kaufzone|pdp-i)\.css/.test(href) && !document.querySelector('link[href="' + href + '"]')){
              var neu = document.createElement('link'); neu.rel = 'stylesheet'; neu.href = href; document.head.appendChild(neu);
            }
          });
        }
        n.removeAttribute('style');
        n.querySelectorAll('[data-shopify-editor-block]').forEach(function(x){ x.removeAttribute('data-shopify-editor-block'); });
        nutzenCache[h] = n.outerHTML;
        tippStand = null; tippsZeichnen();
      })
      .catch(function(){});
    return '';
  }
  function tippsZeichnen(){
    if(!tippKasten) return;
    var liste = !anfrageGilt ? [] : TIPPS.map(function(t){
      var i = presetIdx(adresseParam(t.param));
      return i > -1 ? { t: t, i: i, p: state.presets[i] } : null;
    }).filter(Boolean);
    var stand = liste.map(function(x){ return x.t.param + x.i + (x.p.meta ? 'm' : '') + (state.selPreset === x.i ? 's' : '') + (tippNutzen(x.p) ? 'n' : ''); }).join(',');
    if(stand === tippStand) return;
    tippStand = stand;
    tippKasten.hidden = !liste.length;
    var zub = root.querySelector('[data-role="zubehoer-oben"]'), zubPlatz = tippKasten.querySelector('[data-tipps-zubehoer]');
    if(liste.length && zub && zubPlatz && zub.parentNode !== zubPlatz) zubPlatz.appendChild(zub);
    tippKasten.querySelector('[data-tipps-karten]').innerHTML = liste.map(function(x){
      var sp = x.p.sp || {}, m = x.p.meta || null, sel = state.selPreset === x.i;
      var name = (m && m.karte_name)
        ? (m.karte_zeile ? '<span class="fn-preset-serie">' + esc(m.karte_zeile) + '</span>' : '') + '<span class="fn-preset-name">' + esc(m.karte_name) + '</span>'
        : '<span class="fn-preset-name">' + esc(sp.title || '') + '</span>';
      return '<article class="fn-tipp' + (sel ? ' is-sel' : '') + '" data-tipp-idx="' + x.i + '"'
        + (sp.available ? ' role="button" tabindex="0" aria-pressed="' + sel + '"' : ' aria-disabled="true"') + '>'
        + '<span class="fn-tipp-etiketten"><span class="fn-stufe">' + esc(x.t.wort) + '</span>'
        + (x.t.beste ? '<span class="beste-wahl beste-wahl--akzent">' + esc(d.tBesteWahl || 'Beliebt') + '</span>' : '') + '</span>'
        + '<span class="fn-tipp-media"><span class="fn-haken' + (sel ? ' is-on' : '') + '" aria-hidden="true"></span>'
        + (sp.image ? '<img src="' + esc(sp.image) + '" alt="" loading="lazy">' : '') + '</span>'
        + '<span class="fn-tipp-text">' + name + ((m && m.karte_eck) ? m.karte_eck : '') + '</span>'
        + '<span class="fn-tipp-preis">' + (sp.price != null ? tippPreis(sp.price, m) : '') + '</span>'
        + '<div class="fn-tipp-nutzen">' + tippNutzen(x.p) + '</div>'
        + '</article>';
    }).join('');
    var gew = liste.filter(function(x){ return state.selPreset === x.i; })[0];
    var handy = tippKasten.querySelector('[data-tipps-nutzen-handy]');
    if(handy) handy.innerHTML = gew ? tippNutzen(gew.p) : '';
  }
  function tippWaehlen(ev){
    var karte = ev.target.closest('[data-tipp-idx]');
    if(!karte || karte.getAttribute('aria-disabled') === 'true') return;
    if(ev.type === 'keydown'){ if(ev.key !== 'Enter' && ev.key !== ' ') return; ev.preventDefault(); }
    var i = +karte.getAttribute('data-tipp-idx');
    if(state.selPreset !== i){ selectPreset(i); renderPresets(); }
    tippsZeichnen();
  }
  if(tippKasten){ tippKasten.addEventListener('click', tippWaehlen); tippKasten.addEventListener('keydown', tippWaehlen); }
  if(window.MutationObserver){
    var markWarte = null;
    new MutationObserver(function(){ clearTimeout(markWarte); markWarte = setTimeout(tippsZeichnen, 60); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  tippsZeichnen();
  var teamAn = root.getAttribute('data-team') === '1';
  try{
    if(/[?&]team=1(&|$)/.test(location.search)){ sessionStorage.setItem('fn-team', '1'); adresseSetzen({ team: '' }); }
    if(sessionStorage.getItem('fn-team') === '1') teamAn = true;
  }catch(e){}
  if(teamAn && !istAnfrage){
    var hin = document.createElement('div');
    hin.className = 'fn-team';
    hin.innerHTML = '<button type="button" class="fn-team-kopf" data-team-hin>' + esc(d.tTeamAlsAnfrage || 'Als Anfrage öffnen') + '</button>';
    document.body.appendChild(hin);
    hin.querySelector('[data-team-hin]').addEventListener('click', function(){
      var code = adresseParam('s');
      location.href = location.pathname + '?view=anfrage' + (code ? '&s=' + encodeURIComponent(code) : '');
    });
  }
  if(teamAn && istAnfrage){
    var heute = new Date();
    var heuteWert = heute.getFullYear() + '-' + ('0' + (heute.getMonth() + 1)).slice(-2) + '-' + ('0' + heute.getDate()).slice(-2);
    var vomJetzt = adresseParam('vom');
    var vomWert = /^\d{8}$/.test(vomJetzt) ? vomJetzt.slice(0, 4) + '-' + vomJetzt.slice(4, 6) + '-' + vomJetzt.slice(6) : heuteWert;
    var tool = document.createElement('div');
    tool.className = 'fn-team';
    tool.innerHTML = '<button type="button" class="fn-team-kopf" data-team-auf aria-expanded="false">' + esc(d.tTeamTitel || 'Link für WhatsApp') + '</button>'
      + '<div class="fn-team-leib" hidden>'
      + '<label class="fn-team-wahl"><span>' + esc(d.tTeamDatum || 'Anfrage vom') + '</span><input type="date" data-team-vom value="' + vomWert + '" max="' + heuteWert + '"></label>'
      + '<p class="fn-team-hilfe">' + esc(d.tTeamTippHilfe || '') + '</p>'
      + TIPPS.map(function(t){
          return '<div class="fn-team-tipp" data-tipp="' + t.param + '"><span class="fn-team-tipp-kopf"><b>' + esc(t.wort) + '</b>'
            + '<button type="button" class="fn-team-weg" data-tipp-weg aria-label="–">×</button></span>'
            + '<span class="fn-team-tipp-name" data-tipp-name></span>'
            + '<button type="button" class="fn-team-setzen" data-tipp-setzen>' + esc(d.tTeamUebernehmen || 'Gewählte Halterung übernehmen') + '</button></div>';
        }).join('')
      + '<button type="button" class="fn-team-kopieren" data-team-kopieren>' + esc(d.tTeamKopieren || 'Link kopieren') + '</button>'
      + '<p class="fn-team-hinweis" data-team-meldung></p>'
      + '</div>';
    document.body.appendChild(tool);
    var leib = tool.querySelector('.fn-team-leib');
    var meldung = tool.querySelector('[data-team-meldung]');
    function tippNamen(){
      tool.querySelectorAll('[data-tipp]').forEach(function(z){
        var i = presetIdx(adresseParam(z.getAttribute('data-tipp')));
        var p = i > -1 ? state.presets[i] : null;
        z.querySelector('[data-tipp-name]').textContent = p ? ((p.meta && p.meta.karte_name) ? (p.meta.karte_zeile ? p.meta.karte_zeile + ' · ' : '') + p.meta.karte_name : ((p.sp && p.sp.title) || p.sku)) : '–';
        z.querySelector('[data-tipp-weg]').hidden = !p;
      });
    }
    function tippsNeu(){ tippNamen(); tippsZeichnen(); }
    tool.querySelector('[data-team-auf]').addEventListener('click', function(){
      leib.hidden = !leib.hidden;
      this.setAttribute('aria-expanded', String(!leib.hidden));
      if(!leib.hidden) tippNamen();
    });
    function vomSetzen(){
      var v = (tool.querySelector('[data-team-vom]').value || '').replace(/-/g, '');
      adresseSetzen({ vom: /^\d{8}$/.test(v) ? v : '' });
      var feld = document.querySelector('[data-anfrage-datum]');
      if(feld && v) feld.textContent = ' ' + new Date(+v.slice(0, 4), +v.slice(4, 6) - 1, +v.slice(6)).toLocaleDateString((document.documentElement.lang || 'de').toLowerCase().indexOf('en') === 0 ? 'en-GB' : 'de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    tool.querySelector('[data-team-vom]').addEventListener('change', vomSetzen);
    vomSetzen();
    tool.querySelectorAll('[data-tipp]').forEach(function(z){
      var param = z.getAttribute('data-tipp');
      z.querySelector('[data-tipp-setzen]').addEventListener('click', function(){
        var p = state.selPreset != null ? state.presets[state.selPreset] : null;
        if(!p || !p.sku){ meldung.textContent = d.tTeamErstWaehlen || ''; return; }
        meldung.textContent = '';
        var w = {};
        TIPPS.forEach(function(t){ if(t.param !== param && adresseParam(t.param) === p.sku) w[t.param] = ''; });
        w[param] = p.sku;
        adresseSetzen(w);
        tippsNeu();
      });
      z.querySelector('[data-tipp-weg]').addEventListener('click', function(){
        var w = {}; w[param] = ''; adresseSetzen(w); tippsNeu();
      });
    });
    tool.querySelector('[data-team-kopieren]').addEventListener('click', function(){
      if(!adresseParam('s')){ meldung.textContent = d.tTeamOhneSetup || ''; return; }
      var beste = presetIdx(adresseParam('tz'));
      if(beste > -1 && state.selPreset !== beste){ selectPreset(beste); renderPresets(); tippsZeichnen(); saveState(); }
      adresseSetzen({ k: Math.floor(Date.now() / 3600000).toString(36) });
      var link = location.origin + location.pathname + location.search;
      var fertig = function(){ meldung.textContent = d.tTeamKopiert || ''; };
      if(navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(fertig, function(){ window.prompt('', link); });
      else window.prompt('', link);
    });
  }
})();

